import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'

import { checkWeChatBind, getWeChatQrcode } from '@/api/login'
import useAfterLogin from '@/hooks/useAfterLogin'
import useAfterInformation from '@/hooks/useAfterOnboarding'
import { Button, Checkbox, Message, Radio, Spin } from '@arco-design/web-react'
import IconHot from '@/assets/icon-hot.svg'
import IconRefresh from '@/assets/icon-refresh.svg'
import { IconWechat } from '@arco-design/web-react/icon'
import IconLogo from '@/assets/logo-hd.svg'
import useLang from '@/utils/useLang'
import useLocale from '@/utils/useLocale'

import styles from './style/wechat-login.module.less'
import { useRouter } from 'next/router'
import { clearInviteCode } from '@/utils/checkLogin'
import { baiduRegisterEvent } from '@/utils'
import { getBdVid, getPromotionInfo } from '@/hooks/useBdVid'
import { gtagRegisterEvent } from '@/utils/gtagEvent'
import { qhTrackRegister } from '@/utils/track'

interface IProps {
  type: 'login' | 'register'
  step?: string
  setStep?: Dispatch<SetStateAction<string>>
  sessionFlag?: string
  setSessionFlag?: Dispatch<SetStateAction<string>>
  isEffective?: boolean
  inviteCode?: string
}

export default function WeChatLogin(props: IProps) {
  const router = useRouter()
  const initQrcodeUrl = router.query?.qrcodeUrl || ''
  const { qhclickid } = getBdVid()
  const promotionInfo = getPromotionInfo()
  const { type, step, setStep, sessionFlag, setSessionFlag, inviteCode } = props
  const [qrcodeUrl, setQrcodeUrl] = useState(initQrcodeUrl)
  // const [sessionFlag, setSessionFlag] = useState('')
  const [isExpire, setIsExpire] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const [isAgree, setIsAgree] = useState(false)

  const lang = useLang()
  const t = useLocale()

  const checkId = useRef<NodeJS.Timeout | null>(null)
  const { afterLoginSuccess } = useAfterLogin({ rememberPassword: false })
  const { afterRegisterSuccess } = useAfterInformation({ rememberPassword: false })

  const fetchQrcode = async () => {
    setIsLoading(true)
    const res = await getWeChatQrcode()

    if (res?.data?.data) {
      const { session_flag, url } = res?.data?.data || {}
      url && setQrcodeUrl(url)
      session_flag && setSessionFlag(session_flag)

      setTimeout(() => {
        setIsExpire(true)
        checkId.current && clearTimeout(checkId.current)
      }, 300000)
    }
    setIsLoading(false)
  }

  const checkBind = async () => {
    const res = await checkWeChatBind({
      session_flag: sessionFlag,
      invite_code: inviteCode,
      ...promotionInfo,
      debug: true
    })

    if (res?.data?.data?.access_token) {
      // 登录成功
      clearInviteCode()
      checkId.current && clearTimeout(checkId.current)
      console.log('res?.data?.data', JSON.stringify(res?.data?.data))
      if (res?.data?.data?.event_type === 'signup') {
        baiduRegisterEvent()
        // qhTrackRegister({
        //   qhclickid,
        //   id: res?.data?.data?.user?.user_id
        // })
        gtagRegisterEvent()
      }
      if (res?.data?.data?.user?.region === null || res?.data?.data?.user?.region === null) {
        afterRegisterSuccess('', res?.data)
      } else {
        Message.success(t['login.wechat.success'])
        afterLoginSuccess({}, res?.data)
      }
    } else {
      checkId.current = setTimeout(checkBind, 3000)
    }
  }

  useEffect(() => {
    if (step === '') {
      fetchQrcode()
    }
  }, [])

  useEffect(() => {
    if (qrcodeUrl && sessionFlag) {
      checkId.current = setTimeout(checkBind, 3000)
    }

    return () => {
      checkId.current && clearTimeout(checkId.current)
    }
  }, [qrcodeUrl, sessionFlag])

  return (
    <div style={{ width: '370px' }}>
      <Spin loading={isLoading} style={{ height: '258px', width: '258px', marginBottom: '32px' }}>
        {isExpire && (
          <div
            className={styles['expire-wrap']}
            onClick={() => {
              fetchQrcode()
              setIsExpire(false)
            }}
          >
            <div className={styles['expire']}>
              二维码已失效
              <IconRefresh className={styles['refresh']} />
            </div>
          </div>
        )}

        {step === 'complete' && (
          <div className={styles.next}>
            微信已绑定
            <Button
              onClick={() => {
                if (!isAgree) {
                  Message.error('请先阅读并同意服务协议和隐私协议！')
                  return
                }
                // 不再校验验证码
                // if (!isEffective) {
                //   Message.error('请输入有效的邀请码！')
                //   return
                // }
                setStep('fulfill')
              }}
              className={styles['next-btn']}
            >
              下一步
            </Button>
          </div>
        )}

        {qrcodeUrl && (
          <div style={{ width: '258px', height: '258px' }}>
            <img src={qrcodeUrl} className={styles['qrcode']} />
            {/* <IconLogo className={styles['logo']} /> */}
          </div>
        )}
      </Spin>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div>
          <IconWechat style={{ color: '#00C800', marginRight: '10px', width: '32px', height: '32px' }} />
        </div>
        <div style={{ color: '#403D5A', marginRight: '39px' }}>
          {type === 'register' ? t['register.wechat.scan'] : t['login.wechat.scan']}
        </div>
        {/* {type === 'login' && (
          <div
            style={{ display: 'flex', alignItems: 'center', color: '#655AEC', cursor: 'pointer' }}
            onClick={() => {
              if (lang === 'en-US') {
                window.open('https://wenjuan.feishu.cn/m?t=sL9DYfQRzAFi-9clw')
              } else {
                history.push(`/apply-internal`)
              }
            }}
          >
            {t['login.form.applyTrial']}
            <IconHot style={{ marginLeft: '4px' }} />
          </div>
        )} */}
      </div>
      {type === 'register' && (
        <div style={{ marginTop: '32px' }}>
          {/* <Checkbox
            className={styles['checkbox']}
            checked={isAgree}
            onChange={(checked: boolean) => {
              setIsAgree(checked)
            }}
          ></Checkbox> */}
          {/* Scanning means that you agree to our Terms of Service and Privacy Policy. */}
          <span className={styles['checkbox-text']}>
            {t['register.scan.tip']}
            <a
              href="https://echotik.live/privacy-policy.html"
              target="_blank"
              rel="noreferrer"
              className={styles['checkbox-protocol']}
            >
              {t['register.service.term']}
            </a>
            {t['register.and']}
            <a
              href="https://echotik.live/privacy-policy.html"
              target="_blank"
              rel="noreferrer"
              className={styles['checkbox-protocol']}
            >
              {t['register.privacy.policy']}
            </a>
          </span>
        </div>
      )}
    </div>
  )
}
